import React from 'react';
import { getPieLabelPosition, isLabelHidden } from '../../pieHelpers';

const PieLine = ({
  cx,
  cy,
  midAngle,
  outerRadius,
  stroke,
  percent,
  threshold,
} = {}) => {
  if (isLabelHidden(percent, threshold)) {
    return null;
  }

  const { x0, y0, x, y } = getPieLabelPosition({
    cx,
    cy,
    midAngle,
    outerRadius,
  });

  return <line x1={x0} y1={y0} x2={x} y2={y} stroke={stroke} data-ppuc-id="Chart.PieLine" />;
};

export default PieLine;
